<!-- @format -->

<template>
	<!-- 工具栏 -->
	<pc-layout-main-container ref="ibpsCrud" :gap-placement="gapPlacementParam">
		<template v-if="searchForm || $slots.header || $slots.advancedSearch" #content-header>
			<!-- 查询 -->
			<div
				v-if="searchForm"
				v-show="$utils.isNotEmpty(searchForm) && showToolbar"
				ref="toolbarBox"
				class="toolbar-box clear"
			>
				<template v-if="$slots.searchForm"> </template>
				<template v-else>
					<template v-if="!searchSlot">
						<search-form
							v-if="searchForm"
							ref="searchForm"
							:forms="searchForm.forms || []"
							:size="searchForm.size"
							:fuzzy="searchForm.fuzzy"
							:inline="searchForm.inline"
							:selector="searchForm.selector"
							:label-width="searchForm.labelWidth"
							:item-width="searchForm.itemWidth"
							@collapse-expand-toolbar="handleCollapseExpandToolbar"
							@search="handleSearch"
							@action-event="handleActionEvent"
						>
							<template v-for="item in searchFormSlot" #[item.slotName]>
								<slot :name="item.slotName" :item="item" />
							</template>
							<template v-if="$utils.isNotEmpty(searchToolbars) && searchToolbars" #searchToolbars>
								<pc-toolbar
									:actions="searchToolbars"
									:socpe="thatSocpe"
									:identity="identity"
									position="search"
									@action-event="handleActionEvent"
								/>
							</template>
						</search-form>
					</template>
				</template>
			</div>
			<slot name="advancedSearch" />
			<slot name="header" />
		</template>
		<template #content-main>
			<div class="pc-crud-content">
				<div v-if="hasToolbars || $slots.rightTools" :class="['ibps-toolbar--large']" class="ibps-toolbar">
					<!-- 按钮 -->
					<div
						v-if="hasToolbars"
						class="header"
						:class="$utils.isNotEmpty(searchForm) && showToolbar ? '' : 'ibps-pb-15'"
					>
						<div class="buttons">
							<pc-toolbar
								:actions="getBtnActions(toolbars)"
								:socpe="thatSocpe"
								:access-control="accessControl"
								:identity="identity"
								@action-event="handleActionEvent"
							/>
						</div>
						<slot name="headerOther" />
						<div class="tools">
							<slot name="rightTools" />
						</div>
					</div>
					<div v-else-if="$slots.rightTools" class="pc-right-tools toolbar-box"> </div>
					<div v-else-if="buttonSpace" class="pc-button-space" />
				</div>
				<div class="platform-container-crud__body" :class="hasToolbars || $slots.rightTools ? 'has_tools' : ''">
					<div v-if="summaryData && summaryData.length > 0" class="summaryListSty">
						<el-row :gutter="20">
							<div v-for="(data, dataIndex) in summaryData" :key="dataIndex">
								<el-col v-for="(sumData, sumIndex) in tableColumns" :key="sumIndex" :span="3"> </el-col>
							</div>
						</el-row>
					</div>
					<!--列表-->
					<el-table
						ref="elTable"
						v-loading="loading"
						v-bind="tableOptions"
						class="pc-crud-table"
						:border="false"
						:data="ibpsData"
						:sum-text="sumText"
						:summary-method="defaultSummaryMethod"
						:row-class-name="tableRowClassName"
						:cell-class-name="tableCellClassName"
						@current-change="handleCurrentChange"
						@select="handleSelect"
						@select-all="handleSelectAll"
						@selection-change="handleSelectionChange"
						@sort-change="handleSortChange"
						@cell-mouse-enter="handleCellMouseEnter"
						@cell-mouse-leave="handleCellMouseLeave"
						@cell-click="handleCellClick"
						@cell-dblclick="handleCellDblclick"
						@row-click="handleRowClick"
						@row-contextmenu="handleRowContextmenu"
						@row-dblclick="handleRowDblclick"
						@header-click="handleHeaderClick"
						@header-contextmenu="handleHeaderContextmenu"
					>
						<template #empty>
							<slot v-if="$slots.empty" name="empty" />
							<!-- <mpaas-empty v-else /> -->
						</template>
						<!--选择列 多选-->
						<el-table-column
							v-if="(selectionRow || selectionRow === '') && selectionType === 'checkbox'"
							v-bind="typeof selectionRow === 'Object' ? selectionRow : null"
							:width="selectionRow.width || 40"
							:reserve-selection="selectionRow.reserveSelectione || false"
							type="selection"
							:resizable="false"
						/>
						<!--选择列 单选-->
						<el-table-column
							v-if="(selectionRow || selectionRow === '') && selectionType === 'radio'"
							fixed
							:width="selectionRow.width || 40"
							:resizable="false"
						>
							<template #default="scope">
								<el-radio v-model="selectionRadio" :label="getPkValue(scope.row)"><span>&nbsp;</span></el-radio>
							</template>
						</el-table-column>
						<el-table-column
							v-if="indexRow || indexRow === ''"
							:label="'序号'"
							:fixed="indexFixed()"
							v-bind="typeof indexRow === 'Object' ? indexRow : null"
							:width="handleAttribute(indexRow.label, 55)"
							type="index"
							:resizable="false"
						/>
						<slot name="prepend-column" />
						<template v-for="(column, index) in tableColumns" :key="index">
							<el-table-column
								v-if="showColumn(column)"
								ref="el-table-column"
								:key="index"
								:fixed="fieldFixed(column)"
								:label="handleAttribute(column.label, '')"
								:prop="handleAttribute(column.prop, null)"
								:width="handleAttribute(column.width, null)"
								:min-width="124"
								:class-name="(column.columClassName ? column.columClassName : '') + ' ibps-crud-column'"
								:show-overflow-tooltip="handleAttribute(column.showOverflowTooltip, true)"
								v-bind="column"
								:resizable="false"
							>
								<template #default="scope">
									<!--时间格式-->
									<span v-if="column.dateFormat" class="ibps-table-column"> </span>
									<!--通用过滤器-->
									<span v-else-if="column.filter" class="ibps-table-column">
										{{ handleColumnFilter(column.filter, scope.row[column.prop]) }}
									</span>
									<!-- 下拉组件-->
									<span v-else-if="column.options" class="ibps-table-column">
										<!--stringArray 字符串类型的数组,逗号分隔-->
										<template v-if="column.dataType === 'stringArray'">
											<template
												v-for="(value, i) in handleColumnDataConvert(scope.row[column.prop], column.separator)"
												:key="i"
											>
												<!-- :key="i" -->
												<span v-bind="handleColumnOptionsColor(column, value)">
													{{ handleColumnOptions('label', column.options, value, column) }}
													{{ handleColumnOtherOption(scope.row, column, value) }}
												</span>
												<template
													v-if="handleColumnDataConvert(scope.row[column.prop], column.separator).length - 1 !== i"
													>,</template
												>
											</template>
										</template>
										<!--stringArray 字符串类型的数组-->
										<template v-else-if="column.dataType === 'objectList'">
											<span v-for="(value, j) in scope.row[column.prop]" :key="j">
												{{ value[column.tagLabel] }}
											</span>
										</template>
										<span v-else>
											<span v-if="!column.isLink" v-bind="handleColumnOptionsColor(column, scope.row[column.prop])">
												{{ handleColumnOptions('label', column.options, scope.row[column.prop]) }}
												{{ handleColumnOtherOption(scope.row, column, scope.row[column.prop]) }}
											</span>
										</span>
									</span>
									<!-- tags组件-->
									<span v-else-if="column.tags" class="ibps-table-column">
										<span v-if="$utils.isEmpty(scope.row[column.prop])">
											{{ column.defaultLabel }}
										</span>
										<template v-else>
											<el-tag :type="handleColumnOptions('type', column.tags, scope.row[column.prop], column)">
												{{ handleColumnOptions('label', column.tags, scope.row[column.prop], column) }}
											</el-tag>
										</template>
									</span>
									<!-- link组件-->
									<span v-else-if="column.link" class="ibps-table-column">
										<el-link
											:type="column.type || 'primary'"
											:underline="column.underline || false"
											style="
												display: block;
												width: 100%;
												overflow: hidden;
												white-space: nowrap;
												text-overflow: ellipsis;
											"
											@click="handleColumnLink(column, scope.row)"
										>
											<span> {{ scope.row[column.prop] }} </span>
										</el-link>
									</span>
									<!-- 单个列查看详情 -->
									<span v-else-if="column.isLink" class="ibps-table-column"> </span>
									<!-- 自定义slot组件-->
									<span v-else-if="column.slotName" class="ibps-table-column">
										<!-- 国际化显示 -->
										<span v-if="column.slotName === 'trans'">
											<!-- {{ $IBPS.$t(scope.row[column.prop]) }} -->
											{{ scope.row[column.prop] }}
										</span>
										<!-- 自定义slot -->
										<slot
											v-else
											:name="column.slotName"
											:row="scope.row"
											:value="scope.row[column.prop]"
											:column="column"
										></slot>
									</span>
									<template v-else>
										{{
											column.formatter
												? column.formatter(scope.row, scope.column, _get(scope.row, column.prop), scope.$index)
												: _get(scope.row, column.prop)
										}}
									</template>
								</template>
							</el-table-column>
						</template>

						<!-- 自定义操作列 -->
						<!--自定义列begin-->
						<el-table-column
							v-if="displayField || (rowHandleActions && rowHandleActions.length > 0 && manageStyle)"
							:width="manageButtonWidth"
							align="center"
							:fixed="handleAttribute(rowHandle ? rowHandle.fixed : null, 'right')"
							:resizable="false"
						>
							<template #header>
								<span
									v-if="rowHandleActions && rowHandleActions.length > 0 && manageStyle"
									:class="{ 'ibps-mr-5': displayField }"
								>
									{{ rowHandle.label ? rowHandle.label : '操作' }}
								</span>
								<el-tooltip v-if="displayField" :content="'components.crud.displayField'" placement="top">
									<i
										class="el-icon-s-operation"
										style="cursor: pointer; font-size: 16px"
										@click="displayFieldVisible = true"
									/>
								</el-tooltip>
							</template>
							<template v-if="manageStyle" #default="scope">
								<span class="ibps-row-menu-link">
									<pc-toolbar
										:actions="getRowHandleActions(currentRow)"
										:socpe="thatSocpe"
										:data="scope.row"
										:identity="identity"
										position="manage"
										type="link"
										@click="handleActionClick"
										@action-event="handleActionEvent"
									/>
									<template v-if="hasRowHandleMoreActions(currentRow)">
										<el-dropdown
											:show-timeout="30"
											:hide-timeout="20"
											style="vertical-align: baseline"
											@visible-change="visibleChange"
										>
											<span>
												<el-link :underline="false"
													>更多 <el-icon><CaretBottom /></el-icon
												></el-link>
											</span>
											<template #dropdown>
												<el-dropdown-menu class="ibps-table-dropdown-menu">
													<pc-toolbar
														:actions="getRowHandleMoreActions(currentRow)"
														:socpe="thatSocpe"
														:data="scope.row"
														:identity="identity"
														type="menu"
														position="manage"
														@action-event="handleActionEvent"
													/>
												</el-dropdown-menu>
											</template>
										</el-dropdown>
									</template>
									<span v-else class="ibps-mr-10" />
								</span>
							</template>
						</el-table-column>
						<!--自定义列end-->
					</el-table>
				</div>

				<!--分页 或底部 自定义底部-->
				<div v-if="isShowPagination" ref="ibpsCrudFooter" class="platform-container-crud__footer">
					<template v-if="$slots.footer">
						<slot name="footer" />
					</template>
					<pc-system-pagination
						:pagination="pagination"
						@refresh="handlePaginationRefresh"
						@change="handlePaginationChange"
					/>
				</div>
			</div>
		</template>
	</pc-layout-main-container>
</template>

<script>
	import base from './mixin/base';
	import handleRow from './mixin/handleRow';
	import data from './mixin/data';
	import search from './mixin/search';
	import column from './mixin/column';
	import pagination from './mixin/pagination';
	import displayField from './mixin/displayField';
	import utils from './mixin/utils';

	import SearchForm from './components/search-form/index.vue';
	import { PcLayoutMainContainer } from '@/layout';
	import { $utils } from '@/utils/publicUtils';
	import PcToolbar from '@/components/pc-toolbar/index.vue';
	import PcSystemPagination from '@/components/pc-system-pagination/index.vue';

	export default {
		components: {
			SearchForm,
			PcToolbar,
			PcSystemPagination,
			PcLayoutMainContainer,
		},
		mixins: [base, data, search, column, handleRow, pagination, displayField, utils],
		data() {
			return {
				$utils,
			};
		},
	};
</script>
<style lang="scss" scoped>
	.is-option-color {
		border: 1px solid #dcdfe6;
		border-radius: 12px;
		padding: 0 12px;
		margin: 0 4px;
		color: #606266;
		box-sizing: border-box;
		display: inline-block;
		line-height: 24px;
		min-height: 24px;
	}

	.is-option-color.ibps-field-radio-margin {
		margin-top: 4px;
		margin-bottom: 4px;
	}

	.is-option-color__disabled {
		opacity: 0.8;
	}

	.pc-right-tools {
		display: flex;
		align-items: center;
	}

	.pc-button-space {
		display: inline-block;
		height: 30px;
		width: 100%;
	}

	.pc-crud-content {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;

		.platform-container-crud__body {
			flex: 1;
			overflow: auto;

			.pc-crud-table {
				height: 100%;
			}
		}
	}
</style>
<style lang="scss"></style>
